import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _dec, _class, _class2, _temp;

import React from 'react';
import { themeable } from '@instructure/ui-themeable';
import { Text } from '@instructure/ui-elements';
import { ProgressBar } from '@instructure/ui-progress';
import t from 'format-message';
import { outcomeResultShape, scoringMethodShape } from '../../../store/shapes';
import convertToPoints from '../convertToPoints';
import theme from '../../theme';
var styles = {
  componentId: 'dIVYN',
  template: function template(theme) {
    return "\n\n@media screen and (min-width: 768px) {\n  .outcomes-ui__MasteryCounts--masteryBarGraph {\n    margin-top: 2rem;\n  }\n\n  .outcomes-ui__MasteryCounts--masteryScoreSection {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .outcomes-ui__MasteryCounts--masteryBarGraph {\n    display: none;\n  }\n\n  .outcomes-ui__MasteryCounts--masteryScoreSection {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    margin-top: 2rem;\n  }\n\n  .outcomes-ui__MasteryCounts--masteryScoreBoxAboveMastery {\n    color: ".concat(theme.masteryColor || 'inherit', ";\n    display: flex;\n    flex-direction: column;\n    font-weight: bold;\n    text-align: center;\n  }\n\n  [dir=\"ltr\"] .outcomes-ui__MasteryCounts--masteryScoreBoxAboveMastery {\n    text-align: center;\n  }\n\n  [dir=\"rtl\"] .outcomes-ui__MasteryCounts--masteryScoreBoxAboveMastery {\n    text-align: center;\n  }\n\n  .outcomes-ui__MasteryCounts--masteryScoreBoxBelowMastery {\n    display: flex;\n    flex-direction: column;\n    font-weight: bold;\n    text-align: center;\n  }\n\n  [dir=\"ltr\"] .outcomes-ui__MasteryCounts--masteryScoreBoxBelowMastery {\n    text-align: center;\n  }\n\n  [dir=\"rtl\"] .outcomes-ui__MasteryCounts--masteryScoreBoxBelowMastery {\n    text-align: center;\n  }\n}\n\n.outcomes-ui__MasteryCounts--masteryBarDetails {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 0.25rem;\n}\n\n.outcomes-ui__MasteryCounts--masteryCountText {\n  color: ").concat(theme.masteryColor || 'inherit', ";\n}\n");
  },
  'masteryBarGraph': 'outcomes-ui__MasteryCounts--masteryBarGraph',
  'masteryScoreSection': 'outcomes-ui__MasteryCounts--masteryScoreSection',
  'masteryScoreBoxAboveMastery': 'outcomes-ui__MasteryCounts--masteryScoreBoxAboveMastery',
  'masteryScoreBoxBelowMastery': 'outcomes-ui__MasteryCounts--masteryScoreBoxBelowMastery',
  'masteryBarDetails': 'outcomes-ui__MasteryCounts--masteryBarDetails',
  'masteryCountText': 'outcomes-ui__MasteryCounts--masteryCountText'
};
var Header = (_dec = themeable(theme, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _getPrototypeOf(Header).apply(this, arguments));
  }

  _createClass(Header, [{
    key: "render",
    // eslint-disable-next-line no-undef
    value: function render() {
      var _this$props = this.props,
          outcomeResult = _this$props.outcomeResult,
          scoringMethod = _this$props.scoringMethod;
      var masteryPoints = convertToPoints(scoringMethod.mastery_percent, scoringMethod);
      return React.createElement("div", null, React.createElement("div", {
        className: styles.masteryScoreSection
      }, React.createElement("div", {
        className: styles.masteryScoreBoxAboveMastery
      }, React.createElement(Text, {
        size: "x-large"
      }, outcomeResult.masteryCount), React.createElement(Text, {
        size: "small"
      }, t('Mastery at {mastery} pts', {
        mastery: masteryPoints
      }))), React.createElement("div", {
        className: styles.masteryScoreBoxBelowMastery
      }, React.createElement(Text, {
        size: "x-large"
      }, outcomeResult.count - outcomeResult.masteryCount), React.createElement(Text, {
        size: "small"
      }, t('Didn\'t Meet')))), React.createElement("div", {
        className: styles.masteryBarGraph,
        "data-automation": "outcomeView__masteryBarGraph"
      }, React.createElement(ProgressBar, {
        size: "small",
        screenReaderLabel: t('{count} of {total} met mastery', {
          count: outcomeResult.masteryCount,
          total: outcomeResult.count
        }),
        meterColor: "success",
        valueMax: outcomeResult.count,
        valueNow: outcomeResult.masteryCount
      }), React.createElement("div", {
        className: styles.masteryBarDetails,
        "data-automation": "outcomeView__masteryBarDetails"
      }, React.createElement("div", {
        className: styles.masteryCountText
      }, React.createElement(Text, {
        size: "small",
        "data-automation": "outcomeView__masteryCount"
      }, t('{count} Mastery at {mastery} pts', {
        count: outcomeResult.masteryCount,
        mastery: masteryPoints
      }))), React.createElement(Text, {
        size: "small",
        "data-automation": "outcomeView__noMasteryCount"
      }, t("{count} Didn't Meet", {
        count: outcomeResult.count - outcomeResult.masteryCount
      })))));
    }
  }]);

  Header.displayName = "Header";
  return Header;
}(React.Component), _class2.propTypes = {
  outcomeResult: outcomeResultShape.isRequired,
  scoringMethod: scoringMethodShape.isRequired
}, _temp)) || _class);
export { Header as default };